import { Statistic } from 'models/dashboard';

export const prepareTreatments = (data: Statistic[]) => {
  return data.map((t: Statistic) => ({
    id: t.name,
    label: t.name,
    value: t.quantity
  }));
};
